// extracted by mini-css-extract-plugin
export default {"booking-details":"CreateBookingDetails_booking-details__ah4RB","icon":"CreateBookingDetails_icon__sqjRa"};